import { DPE_COLORS } from '@/config';
import { useLayerStore } from '@/stores/layerStore';

export function Legend() {
  const layers = useLayerStore((s) => s.layers);
  const buildingsVisible = layers.find((l) => l.id === 'buildings')?.visible;

  if (!buildingsVisible) return null;

  return (
    <div className="rounded-lg bg-white/90 px-3 py-2 shadow-md backdrop-blur-sm">
      <p className="mb-1.5 text-xs font-semibold text-gray-700">Étiquette DPE</p>
      <div className="flex gap-1">
        {Object.entries(DPE_COLORS).map(([label, color]) => (
          <div key={label} className="flex flex-col items-center">
            <div
              className="h-4 w-4 rounded-sm"
              style={{ backgroundColor: color }}
            />
            <span className="mt-0.5 text-[10px] font-medium text-gray-600">{label}</span>
          </div>
        ))}
        <div className="flex flex-col items-center">
          <div className="h-4 w-4 rounded-sm bg-gray-400" />
          <span className="mt-0.5 text-[10px] font-medium text-gray-600">N/A</span>
        </div>
      </div>
    </div>
  );
}
